export type LiveKitSessionUsage =
  | {
      policy: "unlimited";
      sessionLimitSeconds: null;
      dailyRemainingSeconds: null;
    }
  | {
      policy: "freemium";
      sessionLimitSeconds: number;
      dailyRemainingSeconds: number;
    };

export type FreeVoiceLimitResponse = {
  code: "FREE_VOICE_DAILY_LIMIT_REACHED";
  usage: {
    policy: "freemium";
    sessionLimitSeconds: 0;
    dailyRemainingSeconds: 0;
  };
};

function readRecord(value: unknown): Record<string, unknown> | null {
  return value && typeof value === "object" ? (value as Record<string, unknown>) : null;
}

export function parseLiveKitSessionUsage(value: unknown): LiveKitSessionUsage | null {
  const usage = readRecord(value);
  if (!usage) return null;

  if (
    usage.policy === "unlimited" &&
    usage.sessionLimitSeconds === null &&
    usage.dailyRemainingSeconds === null
  ) {
    return { policy: "unlimited", sessionLimitSeconds: null, dailyRemainingSeconds: null };
  }

  if (
    usage.policy === "freemium" &&
    Number.isInteger(usage.sessionLimitSeconds) &&
    Number(usage.sessionLimitSeconds) > 0 &&
    Number.isInteger(usage.dailyRemainingSeconds) &&
    Number(usage.dailyRemainingSeconds) >= 0
  ) {
    return {
      policy: "freemium",
      sessionLimitSeconds: Number(usage.sessionLimitSeconds),
      dailyRemainingSeconds: Number(usage.dailyRemainingSeconds),
    };
  }

  return null;
}

export function parseFreeVoiceLimitResponse(
  status: number,
  value: unknown
): FreeVoiceLimitResponse | null {
  if (status !== 429) return null;

  const payload = readRecord(value);
  const usage = readRecord(payload?.usage);
  if (
    payload?.code !== "FREE_VOICE_DAILY_LIMIT_REACHED" ||
    usage?.policy !== "freemium" ||
    usage.sessionLimitSeconds !== 0 ||
    usage.dailyRemainingSeconds !== 0
  ) {
    return null;
  }

  return {
    code: "FREE_VOICE_DAILY_LIMIT_REACHED",
    usage: {
      policy: "freemium",
      sessionLimitSeconds: 0,
      dailyRemainingSeconds: 0,
    },
  };
}
